/* global $ */

import { Controller } from 'stimulus';
import 'select2';

class Select2Controller extends Controller {
  connect() {
    $(this.element).select2();
  }
}

Select2Controller.targets = [
  //
];

export default Select2Controller;
